document.addEventListener("DOMContentLoaded", () => {
  const animated = document.querySelectorAll(".fade-up, .fade-left, .fade-right, .scale-in");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  animated.forEach((el) => {
    if (!el.classList.contains("is-visible-on-load")) observer.observe(el);
  });

  // Badge delay
  const badge = document.querySelector(".founder-frame__badge");
  if (badge) {
    const badgeObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setTimeout(() => badge.classList.add("is-visible"), 350);
        badgeObserver.disconnect();
      }
    }, { threshold: 0.3 });
    badgeObserver.observe(badge);
  }
});
